import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import TagManager from 'react-gtm-module'; // 1. Importa o módulo do GTM

// 2. Insira o código do Tag Manager enviado pelo cliente
const tagManagerArgs = {
    gtmId: 'GTM-TVTDSZHJ' 
};

// 3. Inicializa o GTM antes do React renderizar a árvore de componentes
TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
